export const UserOctagonIcon = ({
  className,
  strokeWidth = '1.5',
}: {
  className?: string
  strokeWidth?: string
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      className={className}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M17.5674 7.15133V12.8513C17.5674 13.7846 17.0674 14.6513 16.2591 15.1263L11.3091 17.9847C10.5008 18.4513 9.50078 18.4513 8.68412 17.9847L3.73411 15.1263C2.92578 14.6597 2.42578 13.793 2.42578 12.8513V7.15133C2.42578 6.218 2.92578 5.3513 3.73411 4.8763L8.68412 2.01797C9.49245 1.5513 10.4924 1.5513 11.3091 2.01797L16.2591 4.8763C17.0674 5.3513 17.5674 6.20966 17.5674 7.15133Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0003 9.16847C11.0726 9.16847 11.9419 8.29914 11.9419 7.22679C11.9419 6.15443 11.0726 5.28516 10.0003 5.28516C8.92791 5.28516 8.05859 6.15443 8.05859 7.22679C8.05859 8.29914 8.92791 9.16847 10.0003 9.16847Z"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3327 13.8846C13.3327 12.3846 11.841 11.168 9.99935 11.168C8.15768 11.168 6.66602 12.3846 6.66602 13.8846"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
